import React, { useEffect, useState } from 'react';
import { Consumer } from "../context";
import { Helmet } from "react-helmet";
import cogoToast from 'cogo-toast';

import Header from "../components/header/header";
import SidebarAdministracion from "../components/header/sidebarAdministracion";
import Controls from '../components/controls/controls';
import BudgetConceptTable from "../components/budgetConcept/budgetConcept";
import DinamicModal from '../components/dinamicModal/dinamicModal';

import DropdownTreeContainer from "./DropdownTreeContainer";

import sortableData from '../helpers/sortableDataTable';
import Permissions from '../middlewares/Permissions';

import 'react-dropdown-tree-select/dist/styles.css'

import Request from "../core/httpClient";

const request = new Request();

function BudgetConcept(props) {

	const { context } = props;

	const [subfraccionamiento, setSubfraccionamiento] = useState(localStorage.getItem('subfrac'));

	const [conceptos, setConceptos] = useState([]);
	const [egr_conceptos, setEgr_conceptos] = useState([]);
	const [showModal, setShowModal] = useState(false);
	const [nombre, setNombre] = useState('');
	const [cuenta_contable, setCuenta_contable] = useState('');
	const [mostrar_app, setMostrar_app] = useState(0);
	const [id_concepto_padre, setId_concepto_padre] = useState(0);

	const [submenu, setSubmenu] = useState('');
	const [lectura, setLectura] = useState(true);
	const [escritura, setEscritura] = useState(false);

	const [empty, setEmpty] = useState(true);
	const [error, setError] = useState(false);
	const [message, setMessage] = useState('');

	const [loadingConceptos, setLoadingConceptos] = useState(false);
	const [loading_egr_Conceptos, setLoading_egr_Conceptos] = useState(false);
	const [loadingSave, setLoadingSave] = useState(false);

	const [page, setPage] = useState(1);
	const [pageLength, setPageLength] = useState(20);
	const [filterColumn, setFilterColumn] = useState({ col: '', filt: '' });
	const [direction, setDirection] = useState({ descripcion: 'desc' });

	const [filtrar, setFiltrar] = useState('');

	useEffect(() => {
		validarPermisos();
		getConceptos();
		get_EGR_Conceptos();
		getSubmenu();
	}, []);

	const validarPermisos = async () => {

		let permisos = new Permissions();

		let permisosInfo = await permisos.getResult()

		setEscritura(permisosInfo.escritura);
		setLectura(permisosInfo.lectura);
	};

	const getSubmenu = async () => {

		const submenu = await context.getSubmenuAdminName();

		if (submenu) {
			setSubmenu(submenu);
		};
	};

	const changeFrac = () => {
		getConceptos();
	};

	const reload = () => {
		getConceptos();
		get_EGR_Conceptos();
	};

	const getConceptos = async () => {

		setConceptos([]);
		setLoadingConceptos(true);

		if (!localStorage.getItem('frac')) {

			return;

		} else {

			let data = { idFraccionamiento: localStorage.getItem('frac') };

			const response = await request.post("/presupuestos/get/all", data);

			if (response && !response.error) {

				if (response.conceptos && !response.empty) {

					setConceptos(response.conceptos);

				} else {
					setEmpty(true);
				};

			} else {
				setError(true);
			};
		};

		setLoadingConceptos(false);
	};

	const get_EGR_Conceptos = async () => {

		setEgr_conceptos([]);
		setLoading_egr_Conceptos(true);

		let data = { id_fraccionamiento: localStorage.getItem('frac'), arbol: true };

		const response = await request.post("/conceptos/get/all", data);

		if (response && !response.error) {

			if (response.conceptos && !response.empty) {

				setEgr_conceptos(response.conceptos);

			} else {
				setEmpty(true);
			};

		} else {
			setError(true);
		};

		setLoading_egr_Conceptos(false);
	};

	const handleSubmit = async (event) => {

		setLoadingSave(true);
		setMessage('');

		event.preventDefault();

		let data = {
			id_concepto_padre: id_concepto_padre,
			nombre: nombre,
			mostrar_app: mostrar_app,
			cuenta_contable: cuenta_contable,
			id_fraccionamiento: localStorage.getItem('frac'),
			id_usuario: context.user.id.id_usuario
		};

		const response = await request.post("/conceptos/concepto/create", data);

		if (response.created) {

			setShowModal(false);
			setNombre('');
			setCuenta_contable('');
			setMostrar_app(0);
			setId_concepto_padre(0);

			closeModal("newBudgetConcept");

			reload();

			cogoToast.success('Concepto agregado.', { position: 'bottom-right' });

		} else {

			cogoToast.error('No se pudo agregar concepto.', { position: 'bottom-right', });
		};

		setLoadingSave(false);
		setNombre('');
	};

	const resetValue = () => {
		setNombre('');
		setCuenta_contable('');
		setMostrar_app(0);
		setId_concepto_padre(0);
	};

	const openModal = async (idModal) => {

		setMessage(null);

		const modal = document.getElementById(idModal);

		if (modal) {
			modal.classList.remove('hide-dinamic-modal');
			modal.classList.add('show-dinamic-modal');
		};

		document.getElementById("newBudgetConcept").focus();
	};

	const closeModal = (idModal) => {

		setMessage(null);

		const modal = document.getElementById(idModal);

		if (modal) {
			modal.classList.add('hide-dinamic-modal');
			modal.classList.remove('show-dinamic-modal');
		};
	};

	const sortableTable = (key) => {

		let sd = new sortableData();

		const { items, direction } = sd.sortBy(key, conceptos, direction[key]);

		setConceptos(items);
		setDirection({ [key]: direction });
		setFilterColumn({ col: key, filt: direction });
	};

	const setFilter = (filter) => {
		setFiltrar(filter);
	};

	const subChange = (sub) => {
		setSubfraccionamiento(sub);
	};

	// Filtro
	const filteredEgrConceptos = React.useMemo(() => {
		if (!egr_conceptos || egr_conceptos.length === 0) return [];

		const rawTree = JSON.parse(JSON.stringify(egr_conceptos[1] || []));

		if (!filtrar) return [egr_conceptos[0], rawTree];

		const filterNodes = (nodes, query) => {
		if (!Array.isArray(nodes)) return [];

		return nodes.reduce((acumulador, node) => {
			let nombreSeguro = "";
			if (node.data && node.data.length > 0 && node.data[0].nombre) {
			nombreSeguro = node.data[0].nombre;
			}

			const isMatch = nombreSeguro.toLowerCase().includes(query.toLowerCase());

			if (!isMatch && node.children) {
			node.children = filterNodes(node.children, query);
			}

			// Si después de filtrar, los hijos quedaron vacíos, DESTRUIMOS la propiedad
			if (node.children && node.children.length === 0) {
			delete node.children;
			}

			const hasChildren = node.children && node.children.length > 0;

			// Conservamos el nodo solo si coincide o si sobrevivieron hijos
			if (isMatch || hasChildren) {
			acumulador.push(node);
			}

			return acumulador;
		}, []);
		};

		const finalTree = filterNodes(rawTree, filtrar);
		return [egr_conceptos[0], finalTree];

	}, [egr_conceptos, filtrar]);

	return (
		<div className="owners column">
			<Helmet>
				<title>{process.env.REACT_APP_NAME} - {submenu}</title>
			</Helmet>
			<Header
				sidebar={true}
				active={'presupuestoConcepto'}
				parent={'presup'}
				panel={'panel2'}
				nav={"administracion"}
				change={changeFrac}
				reload={reload}
			/>
			<div className="row">
				<div className="column" id="sidebar">
					<SidebarAdministracion />
				</div>
				<div className="column" id="content">
					{lectura ?
						<div className="justify-center">
							<div className="container column">
								<Controls
									title={submenu}
									nuevo={() => openModal("newBudgetConcept")}
									dataSet={conceptos}
									setFilter={(filter) => setFilter(filter)}
									subChange={(sub) => subChange(sub)}
									selectSub={false}
									newButton={escritura}
								/>
								{loading_egr_Conceptos ?
									<div className="row justify-center">
										<i className="fas fa-spinner fa-spin"></i>
									</div>
									:
									egr_conceptos.length > 0 &&
									<BudgetConceptTable
										conceptos={conceptos}
										page={page}
										reload={reload}
										escritura={escritura}
										pageLength={pageLength}
										sortBy={(key) => sortableTable(key)}
										filterColumn={filterColumn}
										// variable memorizada
										treeValue={filteredEgrConceptos} 
									></BudgetConceptTable>
								}
								<div className="white-space-16" />
							</div>
						</div>
						:
						null
					}
				</div>
			</div>
			<DinamicModal
				idModal={'newBudgetConcept'}
				sizeModalContainer={'small'}
				title={'Añadir concepto'}
				success={handleSubmit}
				showBtnSuccess={true}
				btnTextSuccess={"GUARDAR"}
				showBtnCancel={true}
				btnTextCancel={"CANCELAR"}
				closeModal={resetValue}
				loadingSave={loadingSave}
				message={message}
			>
				<NewBudgetConcept
					egr_conceptos={egr_conceptos}
					nombre={nombre}
					mostrar_app={mostrar_app}
					cuenta_contable={cuenta_contable}
					setNombre={setNombre}
					setMostrar_app={setMostrar_app}
					setCuenta_contable={setCuenta_contable}
					setId_concepto_padre={setId_concepto_padre}
				/>
			</DinamicModal>
		</div>
	);
};

function NewBudgetConcept(props) {

	const { egr_conceptos, nombre, setNombre, mostrar_app, setMostrar_app, cuenta_contable, setCuenta_contable, setId_concepto_padre } = props;

	const [treeData, setTreeData] = useState([]);
	const [filteredTree, setFilteredTree] = useState([]);

	useEffect(() => {

		if (egr_conceptos.length > 0) {

			setTreeData(egr_conceptos[0]);

			const newNode = disableDeepNodes(egr_conceptos[0]);

			setFilteredTree(newNode);
		};

	}, [egr_conceptos]);

	const disableDeepNodes = (tree, depth = 0) => {

		if (!tree) return null;

		if (Array.isArray(tree)) {
			return tree.map(node => disableDeepNodes(node, depth));
		};

		const newNode = { ...tree };

		if (depth >= 2) {
			newNode.disabled = true;
		};

		if (newNode.children) {
			newNode.children = disableDeepNodes(newNode.children, depth + 1);
		};

		return newNode;
	};

	const onChange = async (currentNode, selectedNodes) => {

		if (selectedNodes[0]) {

			if (selectedNodes[0]._depth < 2)

				setId_concepto_padre(selectedNodes[0].id);

			else {

				setId_concepto_padre(selectedNodes[0].id_parent);
			}

		} else {
			setId_concepto_padre(0);
		};
	};

	return (
		<div className="full row align-center">
			<div className="column full">
				{filteredTree.length > 0 &&
					<div className="input-form-content row full align-center ">
						<div className="column label-duo-big">
							<p><b>Nivel:	</b></p>
						</div>
						<div className="column full">
							<DropdownTreeContainer
								data={filteredTree}
								mode="radioSelect"
								onChange={onChange}
								texts={{ placeholder: 'Seleccione un nivel' }}
							/>
						</div>
						<div className="column label-duo-normal align-end">
						</div>
						<div className="column full">
						</div>
					</div>
				}
				<div className="white-space-8" />
				<div className="input-form-content row full align-center ">
					<div className="column label-duo-big">
						<p><b>Partida:	</b></p>
					</div>
					<div className="column full">
						<input
							type="text"
							name="conceptName"
							id="conceptname"
							value={nombre}
							onChange={event => setNombre(event.target.value)}
							className="input input-modals"
							autoComplete='off'
							maxLength="64"
							required
						/>
					</div>
					<div className="column label-duo-normal align-end">
						<label className="container-check">
							<input
								type="checkbox"
								id="mostrar_app"
								checked={mostrar_app === 1 ? true : false}
								name="mostrar_app"
								onChange={(event) => { setMostrar_app(event.target.checked === true ? 1 : 0) }}
							/>
							<span className="checkmark"></span>
						</label>
					</div>
					<div className="column full">
						<h5>
							{" "}
							<b>Mostrar en la App</b>{" "}
						</h5>
					</div>
				</div>
				<div className="white-space-8" />
				<div className="white-space-8" />
				<div className="white-space-8" />
				<div className="input-form-content row full align-center ">
					<div className="column label-duo-big">
						<p><b>Cuenta contable:	</b></p>
					</div>
					<div className="column full">
						<input
							type="text"
							name="cuenta_contable"
							id="cuenta_contable"
							value={cuenta_contable}
							onChange={event => setCuenta_contable(event.target.value)}
							className="input input-modals"
							autoComplete='off'
							maxLength="64"
						/>
					</div>
					<div className="column label-duo-normal align-end">

					</div>
					<div className="column full">

					</div>
				</div>
				<div className="white-space-8" />
			</div>
		</div>
	);
};

export default Consumer(BudgetConcept);